<!-- @format -->

<div id="gold-status-container">
	<div class="gold-status-header hmf-py-m-xs hmf-py-s-s">
		<span>2 WAYS TO UNLOCK SCORECARD GOLD</span>
	</div>
	<div class="gold-status-text hmf-ml-m-s hmf-ml-s-0 hmf-mr-s-s">
		<ul class="hmf-mr-m-xl">
			<li class="hmf-my-s">
				<span class="text-header"
					>Spend $500+ on qualifed purchases in a calendar year.</span
				>
				<div class="text-content">
					<span class="legal-text"
						>See
						<a
							class="underline"
							href="/s/score-card-terms"
							target="_self"
							>Terms & Conditions</a
						>
						for exclusions and additional details. Please allow 24 hours from
						fulfillment of qualifying purchase for ScoreCard Gold status to be reflected
						on your account.</span
					>
					<common-accordion
						[hideHeaderLine]="true"
						[isTitleCentered]="false"
						[isCollapsed]="true">
						<div
							class="hmf-mt-xxxs gold-status-label"
							myPanelHeader>
							How Close Am I to Gold Status?
						</div>
						<div myPanelBody>
							<scorecard-scorecard-gold
								[abbreviatedVersion]="true"></scorecard-scorecard-gold>
						</div>
					</common-accordion>
				</div>
			</li>
			<li class="hmf-pb-s">
				<span class="text-header">Open and use your ScoreRewards credit card account.</span>
				<shared-components-tool-tip
					class="gold-exclusive-tooltip"
					icon="info-icon-dark.svg"
					textBody="Cardholders must make at least one purchase per calendar year to maintain Gold status.">
				</shared-components-tool-tip>
				<div class="text-content">
					<span class="legal-text"
						>Subject to credit approval. Allow up to 24 hours after approved for Gold
						status to be reflected on your account.</span
					>
					<div class="hmf-mt-xxxs">
						<a
							class="link-font underline"
							href="https://apply.syf.com/applylanding/ApplyLanding?clientCode=DSG"
							target="_self"
							>Apply Now</a
						>
					</div>
				</div>
			</li>
		</ul>
	</div>
</div>
